import { getLastRedirectUri } from '../deep-links';

export const createPlaidHandler = (config) => {
  const { token, onSuccess, onExit, onEvent } = config;

  // Get the OAuth redirect URI if we're returning from OAuth
  const receivedRedirectUri =
    getLastRedirectUri() || localStorage.getItem('receivedRedirectUri');
  const isOAuthRedirect =
    window.location.href.includes('oauth_state_id') ||
    (receivedRedirectUri && receivedRedirectUri.includes('oauth_state_id'));

  // Clear any stored redirect URI since we're using it now
  localStorage.removeItem('receivedRedirectUri');

  // Create the Plaid Link configuration
  const handlerConfig = {
    token,
    onSuccess,
    onExit: (error, metadata) => {
      console.log('Plaid exit:', { error, metadata });
      if (metadata?.status === 'requires_oauth') {
        // Store the link token for OAuth return
        localStorage.setItem('plaid_link_token', token);
      }
      if (onExit) onExit(error, metadata);
    },
    onEvent: (eventName, metadata) => {
      console.log('Plaid event:', eventName, metadata);
      if (onEvent) onEvent(eventName, metadata);
    },
  };

  // If we're handling an OAuth redirect, include the redirect URI
  if (isOAuthRedirect) {
    handlerConfig.receivedRedirectUri =
      receivedRedirectUri || window.location.href;
  }

  // Create and return the handler
  return window.Plaid.create(handlerConfig);
};
